module.exports = __webpack_public_path__ + "img/aa-ss.0e832746.png";